import { render } from "./_SelectText.vue?vue&type=template&id=1a6f0351"
import script from "./_SelectText.vue?vue&type=script&lang=js"
export * from "./_SelectText.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pnz002/Project/dfy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__